module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"thank_you_message_template":{"top":"Thank you for your donation!","middle":"Donation #229","bottom":"View and save the full receipt for your reference. Please check your SMS or email for your receipt copy."}},"id":{}}')
  delete Component.options._Ctor
}
